export const projects = [
    {
        id: 1,
        title: 'CAssess V3',
        category: 'Web Development',
        link: 'https://heal2.poly.asu.edu/cassess/#/about',
        image: 'CAssess.png',
        description: 'The CAssess platform is a comprehensive software application designed to facilitate the management and progress tracking of software projects within an academic environment. It serves as an interface for Professors, Instructors, TAs, and students engaged in these projects, leveraging three primary external tools: Slack, GitHub, and Taiga.'
    },
    {
        id: 2,
        title: '2D/3D Rendering in the Web',
        category: 'Web Development',
        link: 'https://ser-421.vercel.app/babylonjs',
        image: 'RenderingInWeb.png',
        description: 'Authored and implemented content on Babylon.js covering scene creation, materials, physics, animations, interactivity, 3D model importing, and particle systems. '
    },
    {
        id: 3,
        title: 'Linkedin Job Sponsorship Detector',
        category: 'Web Development',
        link: 'https://github.com/vrupak/job-sponsorship-detector',
        image: 'JobGoblin.png',
        description: 'A Chrome extension that highlights H1B and visa sponsorship-related keywords in LinkedIn job descriptions. It also flags companies known to sponsor visas with visual markers both in the job description and the sidebar, helping international job seekers quickly identify relevant opportunities.'
    },
    {
        id: 4,
        title: 'Forbidden Vault',
        category: 'Games',
        link: 'https://github.com/Kushagra1480/SER594_ForbiddenVaults',
        image: 'FVault2.png',
        description: 'Developed a single-player puzzle-adventure game using Unity3D, implementing core gameplay systems including inventory management, buff-debuff mechanics, and procedural dungeon generation. Created custom shaders for magical effects and integrated a modular puzzle system within a cohesive exploration framework. Leveraged C# scripting to build responsive player controls and event-driven interaction mechanics while optimizing performance for smooth gameplay across target platforms.'
    },
    {
        id: 5,
        title: 'ST Runner',
        category: 'Games',
        link: 'https://drive.google.com/file/d/1fYylvaLo7VBHpfjfZWOl-jfnG_-Dvqe1/view?usp=sharing',
        image: 'Runner.png',
        description: 'Led Stranger Things-themed game development session for middle and high school students at SUCCESS summer camp. Created a customizable Unity 2.5D runner game template designed for beginners, enabling students with minimal programming experience to learn fundamental game development concepts through hands-on customization activities.'
    },
    {
        id: 6,
        title: 'ST Room VR',
        category: 'Games',
        link: 'https://drive.google.com/file/d/1z16ErK_KbT0GqQ6ugfVe5SvvlzQBDpOZ/view?usp=sharing',
        image: 'RoomVR.png',
        description: 'Led Stranger Things-themed VR development session for 6th-12th grade students at SUCCESS summer camp. Designed and created an interactive Meta Quest 2 VR experience featuring integrated simple tasks, enabling students to gain hands-on understanding of virtual reality technology through practical engagement.'
    },
    {
        id: 7,
        title: 'Fragrance.net Redesign',
        category: 'Web Design',
        link: 'https://github.com/vrupak/Usability-Enhancement-Project-Fragrance.net-Redesign',
        image: 'Fragrance.png',
        description: 'Conducted comprehensive usability analysis of fragrance.net, identifying key experience issues. Created an optimized prototype using Axure RP 10 that enhanced e-commerce functionality and improved overall design flow. Targeted two critical user tasks for enhancement and validated improvements through rigorous comparative usability testing against the original website.'
    },
    {
        id: 8,
        title: 'CRM Mock Frontend',
        category: 'Web Design',
        link: 'https://sapling-mock.vercel.app/',
        image: 'CRM-Mock.png',
        description: 'Designed and developed a high-fidelity front-end mockup of a CRM tailored for non-profit donor management using Next.js. Focused on creating an intuitive user experience for complex data sets, featuring a "Contacts" dashboard with conceptualized KPIs for 8,000+ constituents and tiered donor segmentation. Built a functional "Events" module that includes an interactive venue layout tool with drag-and-drop table placement and real-time seat capacity tracking. The project demonstrates a strong command of component-based architecture, clean data visualization, and the   ability to translate complex business requirements into a professional, user-centric interface.'
    },
    {
        id: 9,
        title: 'Apple Website Prototype',
        category: 'Web Design',
        link: 'https://er3wb8.axshare.com/?id=2im3yc&p=home&sc=3',
        image: 'Apple-Website.png',
        description: 'Recreated the main page of apple.com using Axure RP, replicating its layout, fonts, icons, colors, menus, and core interactions. Published the interactive prototype on Axshare to match the original website’s look and feel.'
    },
    {
        id: 10,
        title: 'Camera Store E-Commerce Prototype',
        category: 'Web Design',
        link: 'https://d2ckn2.axshare.com/?g=4&id=04c1i2&p=homepage',
        image: 'Camera-Store.png',
        description: 'Developed a high-fidelity e-commerce prototype for a camera store using Axure RP, featuring an intuitive UI with responsive hover effects and structured information architecture. Implemented comprehensive shopping features including mega menu navigation, featured product displays, and category organization. Created interactive elements like promotional banners and newsletter signup to enhance user engagement. Design prioritizes conversion optimization while maintaining strong SEO foundations through strategic content placement and accessibility considerations.'
    },
];